import $ from 'jquery';
$.ajaxSetup({
	headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
	}
});

$(document).ready(function(){
	$('#country_id').on('change', function(){
		$.post('/get_city', {country_id: this.value}, function(response){
			const length = response.length;
			let options = '';
			for(let i = 0; i < length; i++){
				options += `<option value='${response[i].id}'>${response[i].name}</option>`;
				$('#city_id').html(options).removeAttr('disabled');
			}

		})
	}).trigger('change');
})